import { memo } from 'react';

interface EmailProps {
    email: string | undefined;
}

export const Email = memo((props: EmailProps) => {
    const { email } = props;
    return email;
});
Email.displayName = 'Email';
